import React from 'react'
import SharedNotesModal from './SharedNotesModal'

const ModalProtocolNotes = ({closeModal, protocolInfo}) => {
    const protocolName = protocolInfo?.name ?? protocolInfo?.protocol_name ?? '';

    return (
        <SharedNotesModal
            closeModal={closeModal}
            entityInfo={protocolInfo}
            title={`${protocolName}: Protocol Notes`}
            fetchPath='/protocol_notes/protocol/'
            createPath='/protocol_notes/'
            createEntityKey='protocol'
        />
    )
}

export default ModalProtocolNotes